import { isErrorData, isFetchBaseQueryError, isFetchBaseQueryErrorData } from 'shared/helpers/guard';
import { format, parse } from 'date-fns';
import { DowntimesStatus, ZupRequestStatusType } from 'shared/enums';
import { DataEmployees, TItemsTab, TDataEmployeer, TResponseErrorData } from 'shared/types/types';
import { TEmploee } from 'app/services/edpApiV1/employees';

import moment from 'moment';
import { PICKER_DATE_MASK, PICKER_TIME_MASK, SERVER_DATE_MASK } from 'shared/constants';
import {
  INewsGetResponse,
  TAddUserEmployee,
  TNewsEmployeeFromBack,
  TNewsEmployeeToSearch,
  TPrepareNewsToSaveData,
} from 'shared/types/news.types';
import {
  OvertimeUserPreparedInfo,
  TOvertimeGetByIdResponse,
  TOvertimeGetResponse,
  TPreparedOvertime,
  TPreparedOvertimeUsers,
  TUserOvertimeInfo,
} from 'shared/types/overtime.types';
import {
  IPreparedFaqPublicated,
  TFaqCategoryPublicated,
  TFaqGetResponse,
  TGetFaqByIdResponse,
} from 'shared/types/faq.types';
import {
  RvdTimeProps,
  RvdUserPreparedInfo,
  TPreparedRvd,
  TPreparedRvdUsers,
  TRvdGetResponse,
  TRvdResponseData,
  TUserRvdInfo,
} from 'shared/types/rvd.types';
import {
  TAbsentInfo,
  TAbsentSingleInfo,
  TAbsentSingleInfoData,
  TPreparedSingleAbsenceTable,
} from 'shared/types/absence.types';
import { TVacationInfo, TVacationUserInfo } from 'shared/types/vacations.types';
import {
  TPreparedReferencesData,
  TPreparedReferencesUserDataInfo,
  TReferencesDataInfo,
  TReferencesInfo,
} from 'shared/types/reference.types';
import {
  TConsultationsForm,
  TConsultationsInfo,
  TConsultationsPreparedData,
  TSingleConsultationInfo,
  TSingleConsultationPreparedData,
} from 'shared/types/consultations.types';
import {
  DataDaysScheduleType,
  TPreparedAcceptSettings,
  TTypeSchedule,
  TVacationScheduleInfo,
  TVacationScheduleRequest,
  TVacationScheduleRequestPrepared,
  TVacationScheduleSubordinate,
  TVacationScheduleSubordinatePrepared,
  TVacationSupervisers,
} from 'shared/types/vacation-schedule.types';
import { OvertimeFormFields, WORK_TIME_OVER_MESSAGE_OVERTIME } from 'shared/constants/overtime';
import { FormInstance, notification } from 'antd';
import {
  RvdCompensationType,
  RvdExcellCompensationTypeFromBack,
  RvdStatusesBack,
  RvdStatusFromBack,
} from 'shared/enums/rvd';
import {
  OvertimeCompensationType,
  OvertimeExcellCompensationTypeFromBack,
  overtimeStatusFromBack,
} from 'shared/enums/overtime';
import { AdminsData, AdminsDataPrepared } from 'shared/types/admins.types';
import { DEFAULT_CATEGORY_ICON, DEFAULT_CATEGORY_NAME, DEFAULT_CATEGORY_VALUE } from 'shared/constants/faq';
import {
  TAnswerUsersInfoPrepared,
  TPreparedPollsPublicated,
  IPollGetResponse,
  TGetPollResultsResponsePaginated,
  TGetPollResultsResponse,
  IPollGetByIdResponse,
} from 'shared/types/poll.types';
import {
  TDayOffResponse,
  TDayOffResponseCanceled,
  TDayOffSingleResponse,
  TPreparedDayOffPublicated,
} from 'shared/types/dayoff.types';
import { ExtraVacationsTypes } from 'shared/enums/vacations';
import dayjs from 'dayjs';
import { TPreparedVacationApplicationInfo, VacationApplicationInfo } from 'app/services/edpApiV1/vacationApplication';
import { TPreparedVacationSupervisorInfoData } from 'features/vacations-application/vacationPull';
import { VacationSupervisor } from 'app/services/edpApiV1/supervisor/vacationApplication';
import {
  TAbsenceGetResponseSubstitution,
  TPreparedAbsenceSupervisor,
} from 'app/services/edpApiV1/supervisor/absenceSupervisor';
import {
  TDayOffSupervisorResponse,
  TPerparedDayOffSupervisor,
} from 'app/services/edpApiV1/supervisor/dayoffSupervisor';
import {
  TVacationScheduleRequestSupervisor,
  VacationScheduleSupervisor,
} from 'app/services/edpApiV1/supervisor/vacationsSchedule';
import { PICKER_DATE_MASK_PREPARE_UTC } from 'shared/constants/date';
import {
  FrequencyDates,
  FrequencyDatesBack,
  WeekDays,
  WeekDaysBack,
  WeekDaysToBack,
  WeekDaysToFront,
} from 'shared/enums/news';
import { checkOvertimeCompensationType, checkRvdCompensationType } from './type-check';
import { calcWorkDayDuration, calcWorkDayDurationOvertime } from './date';
import { returnErrorOrMessage } from './errors';

export const getCreateAbsenceDate = (date: string) => {
  return moment(date, PICKER_DATE_MASK).format(SERVER_DATE_MASK);
};

export const getErrorData = (error: unknown) => {
  const errorResult = isFetchBaseQueryError(error) && error.data;
  const errorData = isFetchBaseQueryErrorData(errorResult) && errorResult;
  return errorData || null;
};

export const replaceType = (value: DowntimesStatus) => {
  if (value === DowntimesStatus.creation) {
    return 'Оформление';
  } else if (value === DowntimesStatus.transfer) {
    return 'Перенос';
  } else if (value === DowntimesStatus.cancellation) {
    return 'Отмена';
  } else {
    return 'Тип не определён';
  }
};

export const replaceConsultationStatusType = (value: string, flag: string) => {
  type TStatuses = {
    sent: { type: string; text: string };
    inProgress: { type: string; text: string };
    completed: { type: string; text: string };
    warning: { type: string; text: string };
    registered: { type: string; text: string };
    hr_is_in_charge: { type: string; text: string };
    rejected: { type: string; text: string };
    transferred_to_accountant: { type: string; text: string };
    accountant_is_in_charge: { type: string; text: string };
    transferred_to_hr: { type: string; text: string };
    ready: { type: string; text: string };
    received: { type: string; text: string };
  };

  type TStatus = {
    type: string;
    text: string;
  };

  const objectStatus: TStatus = {
    type: '',
    text: '',
  };

  const typesStatuses: TStatuses = {
    sent: { type: 'default', text: 'sent' },
    inProgress: { type: 'processing', text: 'inProgress' },
    completed: { type: 'success', text: 'completed' },
    warning: { type: 'warning', text: 'warning' },
    registered: { type: 'success', text: 'registered' },
    hr_is_in_charge: { type: 'processing', text: 'hr_is_in_charge' },
    rejected: { type: 'error', text: 'rejected' },
    transferred_to_accountant: { type: 'processing', text: 'transferred_to_accountant' },
    accountant_is_in_charge: { type: 'processing', text: 'accountant_is_in_charge' },
    transferred_to_hr: { type: 'processing', text: 'transferred_to_hr' },
    ready: { type: 'success', text: 'ready' },
    received: { type: 'success', text: 'received' },
  };

  const accordanceTypes = {
    sent: { type: 'default', text: 'Отправлено' },
    inProgress: { type: 'processing', text: 'В работе' },
    completed: { type: 'success', text: 'Завершено' },
    warning: { type: 'warning', text: 'Не определён' },
    registered: { type: 'success', text: 'Зарегистрирована' },
    hr_is_in_charge: { type: 'processing', text: 'Изготовление' },
    rejected: { type: 'error', text: 'Отклонена' },
    transferred_to_accountant: { type: 'processing', text: 'Передана в бухгалтерию' },
    accountant_is_in_charge: { type: 'processing', text: 'В работе у бухгалтера' },
    transferred_to_hr: { type: 'processing', text: 'Передана Hr-специалисту' },
    ready: { type: 'success', text: 'Готова к выдаче' },
    received: { type: 'success', text: 'Выдана' },
  };

  if (flag === 'statusType') {
    if (value === typesStatuses.sent.text) {
      return (objectStatus.type = accordanceTypes.sent.type);
    } else if (value === typesStatuses.inProgress.text) {
      return (objectStatus.type = accordanceTypes.inProgress.type);
    } else if (value === typesStatuses.completed.text) {
      return (objectStatus.type = accordanceTypes.completed.type);
    } else if (value === typesStatuses.registered.text) {
      return (objectStatus.type = accordanceTypes.registered.type);
    } else if (value === typesStatuses.hr_is_in_charge.text) {
      return (objectStatus.type = accordanceTypes.hr_is_in_charge.type);
    } else if (value === typesStatuses.transferred_to_accountant.text) {
      return (objectStatus.type = accordanceTypes.transferred_to_accountant.type);
    } else if (value === typesStatuses.accountant_is_in_charge.text) {
      return (objectStatus.type = accordanceTypes.accountant_is_in_charge.type);
    } else if (value === typesStatuses.rejected.text) {
      return (objectStatus.type = accordanceTypes.rejected.type);
    } else if (value === typesStatuses.transferred_to_hr.text) {
      return (objectStatus.type = accordanceTypes.transferred_to_hr.type);
    } else if (value === typesStatuses.ready.text) {
      return (objectStatus.type = accordanceTypes.ready.type);
    } else if (value === typesStatuses.received.text) {
      return (objectStatus.type = accordanceTypes.received.type);
    } else {
      return (objectStatus.type = accordanceTypes.warning.type);
    }
  } else {
    if (value === typesStatuses.sent.text) {
      return (objectStatus.text = accordanceTypes.sent.text);
    } else if (value === typesStatuses.inProgress.text) {
      return (objectStatus.text = accordanceTypes.inProgress.text);
    } else if (value === typesStatuses.completed.text) {
      return (objectStatus.type = accordanceTypes.completed.text);
    } else if (value === typesStatuses.registered.text) {
      return (objectStatus.type = accordanceTypes.registered.text);
    } else if (value === typesStatuses.hr_is_in_charge.text) {
      return (objectStatus.type = accordanceTypes.hr_is_in_charge.text);
    } else if (value === typesStatuses.transferred_to_accountant.text) {
      return (objectStatus.type = accordanceTypes.transferred_to_accountant.text);
    } else if (value === typesStatuses.accountant_is_in_charge.text) {
      return (objectStatus.type = accordanceTypes.accountant_is_in_charge.text);
    } else if (value === typesStatuses.rejected.text) {
      return (objectStatus.type = accordanceTypes.rejected.text);
    } else if (value === typesStatuses.transferred_to_hr.text) {
      return (objectStatus.type = accordanceTypes.transferred_to_hr.text);
    } else if (value === typesStatuses.ready.text) {
      return (objectStatus.type = accordanceTypes.ready.text);
    } else if (value === typesStatuses.received.text) {
      return (objectStatus.type = accordanceTypes.received.text);
    } else {
      return (objectStatus.text = accordanceTypes.warning.text);
    }
  }
};

export const downtimeStatusCreated = (
  type: 'references' | 'vacations' | 'consultations',
  workingDaysPassed?: number,
): 'green' | 'yellow' | 'red' => {
  if (workingDaysPassed) {
    const daysToYellow = 3;
    if (workingDaysPassed === daysToYellow) return 'yellow';
    if (workingDaysPassed > daysToYellow) return 'red';
  }
  return 'green';
};

export const dataForNewsTable = (data: INewsGetResponse[] | null) => {
  if (Array.isArray(data)) {
    const dataForTable = data?.map((el: INewsGetResponse) => {
      return {
        id: el.id || 0,
        created: moment(el?.created).format(PICKER_DATE_MASK),
        fio: `${el.author.lastName} ${el.author.name} ${el.author.middleName}`,
        title: el?.title,
        data: el?.content,
      };
    });
    return dataForTable;
  }
};

export const dataForAnswerUsersTable = (
  data: TGetPollResultsResponsePaginated | undefined,
): TAnswerUsersInfoPrepared[] | undefined => {
  const dataForTable = data?.data.map((el: TGetPollResultsResponse) => {
    return {
      fio: `${el.employee.lastName} ${el.employee.name} ${el.employee.middleName}`,
      division: el.employee.division,
      ownAnswer: el.answer.value,
    };
  });
  return dataForTable;
};

export const dataForPollsInfoTable = (data: IPollGetResponse[] | undefined): TPreparedPollsPublicated[] | undefined => {
  if (Array.isArray(data)) {
    const dataForTable = data?.map((el: IPollGetResponse) => {
      return {
        id: el.id || 0,
        key: el.id || 0,
        created: moment(el?.created).format(PICKER_DATE_MASK),
        fio: `${el.author.lastName} ${el.author.name} ${el.author.middleName}`,
        title: el?.title,
      };
    });
    return dataForTable;
  }
};

export const dataForAddUserTable = (data: TNewsEmployeeFromBack[]): TAddUserEmployee[] => {
  return data.map(elem => ({
    key: elem?.id,
    id: elem?.id,
    fio: `${elem?.lastName} ${elem?.name} ${elem?.middleName || ''}`,
    personnelNumber: elem.personnelNumber,
    division: elem?.division,
  }));
};

export const dataForFaqCategoryTable = (data: TGetFaqByIdResponse[], isLast: boolean): TFaqCategoryPublicated[] => {
  const newData = data.map(elem => ({
    author: '',
    created: '',
    icon: elem.icon,
    id: elem.id,
    title: elem.name,
  }));
  if (isLast) {
    newData.push({
      author: '',
      created: '',
      icon: DEFAULT_CATEGORY_ICON,
      id: DEFAULT_CATEGORY_VALUE,
      title: DEFAULT_CATEGORY_NAME,
    });
  }
  return newData;
};

export const dataForAddUserSearchTable = (data: TNewsEmployeeToSearch[]): TAddUserEmployee[] => {
  return data.map(elem => ({
    key: elem?.id,
    id: elem?.id,
    fio: `${elem?.lastName} ${elem?.name} ${elem?.middleName || ''}`,
    personnelNumber: elem.personnelNumber,
    division: elem?.division.name,
  }));
};

export const dataForAcceptSettingsTable = (data: TVacationSupervisers[]): TPreparedAcceptSettings[] => {
  return data.map(elem => {
    return {
      key: elem.id,
      division: elem.name,
      fio: elem.supervisor ? `${elem.supervisor.lastName} ${elem.supervisor.name} ${elem.supervisor.middleName}` : '—',
      agreementDepth: elem.agreementDepth,
    };
  });
};

export const dataForVacationTable = (data: TVacationInfo[] | null) => {
  if (Array.isArray(data)) {
    const dataForTable = data?.map((el: TVacationInfo) => {
      return {
        key: el?.id,
        created: format(new Date(el?.created), 'dd.MM.yyyy'),
        fio: `${el?.employee?.lastName} ${el?.employee?.name} ${el?.employee?.middleName || ''}`,
        vacationType: el.isUnpaid ? ExtraVacationsTypes.UNPAID : el?.vacationType?.name,
        type: replaceType(el?.type),
        startedAt: format(new Date(el?.startedAt), 'dd.MM.yyyy'),
        endedAt: format(new Date(el?.endedAt), 'dd.MM.yyyy'),
        applyStep: `${el.agreements.step}/${el.agreements.all}`,
        amountDays: el?.amountDays,
        id: el?.id,
        status: {
          type: el.status.type,
          text: el?.status?.name,
          isSupervisorApproved: el.isSupervisorApproved,
          steps: el?.agreements?.all || null,
        },
        hr: el?.hr,
        employee: el?.employee,
        zupRequestStatus: el?.zupRequestStatus,
      };
    });
    return dataForTable;
  }
  return [];
};

export const dataForVacationApplicationTable = (
  data: VacationApplicationInfo[] | null,
): TPreparedVacationApplicationInfo[] => {
  if (Array.isArray(data)) {
    const dataForTable = data.map((el: VacationApplicationInfo) => {
      return {
        key: el?.request.id,
        fio: `${el?.lastName} ${el?.name} ${el?.middleName}`,
        vacationType: el.request.isUnpaid ? ExtraVacationsTypes.UNPAID : el?.request.vacationType?.name,
        type: replaceType(el?.request.type),
        startedAt: dayjs(el?.request.startedAt, SERVER_DATE_MASK).format(PICKER_DATE_MASK),
        endedAt: dayjs(el?.request.endedAt, SERVER_DATE_MASK).format(PICKER_DATE_MASK),
        applyStep: `${el?.step?.depth}/${el?.amountSteps}`,
        amountDays: el?.request.amountDays,
        id: el?.id,
        status: {
          type: 'processing',
          text: el?.request.status?.name,
        },
      };
    });
    return dataForTable;
  }
  return [];
};

export const dataForDayOffTablesCancel = (data: TDayOffResponseCanceled[]): TPreparedDayOffPublicated[] => {
  const newData: TPreparedDayOffPublicated[] = data.map(elem => {
    const request = elem.request;
    const startDate = format(new Date(request.date), 'dd.MM.yyyy');
    const endDate = dayjs(request.date, SERVER_DATE_MASK).add(request.amount - 1, 'day');
    return {
      created: format(new Date(elem.created), 'dd.MM.yyyy'),
      dayOffDate: startDate,
      endedAt: format(new Date(endDate.toDate()), 'dd.MM.yyyy'),
      employee: request.employee,
      fio: `${request.employee.lastName} ${request.employee.name} ${request.employee.middleName}`,
      id: elem.id,
      key: elem.id,
      status: elem.status,
    };
  });

  return newData;
};

export const dataForDayOffTables = (data: TDayOffResponse[]): TPreparedDayOffPublicated[] => {
  const newData: TPreparedDayOffPublicated[] = data.map(elem => {
    const startDate = format(new Date(elem.date), 'dd.MM.yyyy');
    const endDate = dayjs(elem.date, SERVER_DATE_MASK).add(elem.amount - 1, 'day');
    return {
      created: format(new Date(elem.created), 'dd.MM.yyyy'),
      dayOffDate: startDate,
      employee: elem.employee,
      endedAt: format(new Date(endDate.toDate()), 'dd.MM.yyyy'),
      fio: `${elem.employee.lastName} ${elem.employee.name} ${elem.employee.middleName}`,
      id: elem.id,
      key: elem.id,
      status: elem.status,
    };
  });

  return newData;
};

export const dataForVSSubsTable = (data: VacationScheduleSupervisor[]): TVacationScheduleSubordinatePrepared[] => {
  return data.map(elem => {
    return {
      key: elem.id,
      fio: `${elem.lastName} ${elem.name} ${elem.middleName}`,
      id: elem.id,
      requests: elem.requests,
      scheduleRequests: elem.scheduleRequests,
    };
  });
};

export const dataForVSSubsUsersTable = (
  data: TVacationScheduleRequestSupervisor[],
  fio: string,
): TVacationScheduleRequestPrepared[] => {
  return data?.map(elem => {
    const newData: TVacationScheduleRequestPrepared = {
      id: elem.id,
      key: elem.id,
      fio,
      vacationType: elem.vacationType.name,
      type: elem.status.type,
      startedAt: dayjs(elem.startedAt, SERVER_DATE_MASK).format(PICKER_DATE_MASK),
      endedAt: dayjs(elem.endedAt, SERVER_DATE_MASK).format(PICKER_DATE_MASK),
      amountDays: elem.amountDays,
      status: elem.status,
    };
    return newData;
  });
};

export const dataForDayOffUserTables = (data: TDayOffSingleResponse[]): TPreparedDayOffPublicated[] => {
  const newData: TPreparedDayOffPublicated[] = data.map(elem => {
    const startDate = format(new Date(elem.date), 'dd.MM.yyyy');
    const endDate = dayjs(elem.date, SERVER_DATE_MASK).add(elem.amount - 1, 'day');

    return {
      created: format(new Date(elem.created), 'dd.MM.yyyy'),
      dayOffDate: startDate,
      endedAt: format(new Date(endDate.toDate()), 'dd.MM.yyyy'),
      employee: elem.employee,
      fio: `${elem.employee.lastName} ${elem.employee.name} ${elem.employee.middleName}`,
      id: elem.id,
      key: elem.id,
      status: elem.status,
    };
  });

  return newData;
};

export const dataForDayOffUserTablesCanceled = (data: TDayOffResponseCanceled[]): TPreparedDayOffPublicated[] => {
  const newData: TPreparedDayOffPublicated[] = data.map(elem => {
    const request = elem.request;
    const startDate = format(new Date(request.date), 'dd.MM.yyyy');
    const endDate = dayjs(request.date, SERVER_DATE_MASK).add(request.amount - 1, 'day');
    return {
      created: format(new Date(elem.created), 'dd.MM.yyyy'),
      dayOffDate: startDate,
      endedAt: format(new Date(endDate.toDate()), 'dd.MM.yyyy'),
      employee: request.employee,
      fio: `${request.employee.lastName} ${request.employee.name} ${request.employee.middleName}`,
      id: elem.id,
      key: elem.id,
      status: elem.status,
    };
  });

  return newData;
};

export const dataObjectForTable = (data: TVacationInfo | undefined) => {
  if (typeof data === 'object' && data !== null) {
    const dataArray: any[] = [];
    const dataObject = {
      key: data?.id,
      fio: `${data?.employee?.lastName} ${data?.employee?.name} ${data?.employee?.middleName || ''}`,
      created: format(new Date(data?.created), 'dd.MM.yyyy'),
      type: replaceType(data?.type),
      vacationType: data?.vacationType?.name,
      startedAt: format(new Date(data?.startedAt), 'dd.MM.yyyy'),
      endedAt: format(new Date(data?.endedAt), 'dd.MM.yyyy'),
      amountDays: data?.amountDays,
      id: data?.id,
      status: { type: 'processing', text: data?.status?.name, isSupervisorApproved: data.isSupervisorApproved },
      hr: data?.hr,
      employee: data?.employee,
      rejectionReason: data?.rejectionReason,
      scheduleStartedOld: data?.scheduleRequest?.startedAt,
      scheduleEndedOld: data?.scheduleRequest?.endedAt,
    };
    dataArray.push(dataObject);
    const array = dataArray;
    return array;
  }
};

export const dataObjectForVATable = (elem: VacationApplicationInfo | undefined) => {
  if (typeof elem === 'object' && elem !== null && elem !== undefined) {
    const dataArray: any[] = [];
    const dataObject = {
      key: elem.id,
      fio: `${elem.lastName} ${elem.name} ${elem.middleName}`,
      type: replaceType(elem.request.type),
      vacationType: elem.request.vacationType.name,
      startedAt: dayjs(elem.request.startedAt, SERVER_DATE_MASK).format(PICKER_DATE_MASK),
      endedAt: dayjs(elem.request.endedAt, SERVER_DATE_MASK).format(PICKER_DATE_MASK),
      amountDays: elem.request.amountDays,
      id: elem.id,
      status: {
        type: 'processing',
        text: elem.request.status?.name,
      },
      rejectionReason: elem.request.rejectionReason,
    };
    dataArray.push(dataObject);
    const array = dataArray;
    return array;
  }
};

export const dataObjectForVacationTable = (data: TVacationUserInfo | undefined) => {
  if (typeof data === 'object' && data !== null) {
    const dataArray: any[] = [];
    const dataObject = {
      key: data?.id,
      fio: `${data?.employee?.lastName} ${data?.employee?.name} ${data?.employee?.middleName || ''}`,
      created: format(new Date(data?.created), 'dd.MM.yyyy'),
      type: replaceType(data?.type),
      vacationType: data?.vacationType?.name,
      startedAt: format(new Date(data?.startedAt), 'dd.MM.yyyy'),
      endedAt: format(new Date(data?.endedAt), 'dd.MM.yyyy'),
      amountDays: data?.amountDays,
      id: data?.id,
      status: { type: 'processing', text: data?.status?.name, isSupervisorApproved: data.isSupervisorApproved },
      hr: data?.hr,
      employee: data?.employee,
      rejectionReason: data?.rejectionReason,
      scheduleStartedOld: data?.scheduleRequest?.startedAt,
      scheduleEndedOld: data?.scheduleRequest?.endedAt,
      zupRequestStatus: data?.zupRequestStatus,
    };
    dataArray.push(dataObject);
    const array = dataArray;
    return array;
  }
};

export const dataForConsultationsTable = (data: TConsultationsInfo[]) => {
  if (Array.isArray(data)) {
    const dataForTable: TConsultationsPreparedData[] = data?.map(el => {
      return {
        key: el?.id,
        id: el?.id,
        created: format(new Date(el?.created), 'dd.MM.yyyy'),
        topic: el?.topic,
        fio: `${el?.user?.lastName} ${el?.user?.name} ${el?.user?.middleName || ''}`,
        position: el?.user?.position,
        division: el?.user?.division,
        consultant: el?.consultant,
        status: {
          type: replaceConsultationStatusType(el?.status, 'statusType'),
          text: replaceConsultationStatusType(el?.status, 'statusText'),
        },
        downtimeStatus: downtimeStatusCreated('consultations', el?.workingDaysPassed),
        isHRReplied: el?.isHRReplied,
      };
    });
    return dataForTable;
  }
};

export const dataForUserConsultations = (data: TSingleConsultationInfo) => {
  if (typeof data === 'object' && data !== null) {
    const dataObject = {
      key: data?.id,
      id: data?.id,
      fio: `${data?.user?.lastName} ${data?.user?.name} ${data?.user?.middleName || ''}`,
      created: format(new Date(data?.created), 'dd.MM.yyyy'),
      personnelNumber: data?.user?.personnelNumber,
      topicid: data?.topicid,
      topic: data?.topic,
      subtopic: data?.subtopic,
      status: {
        type: replaceConsultationStatusType(data?.status, 'statusType'),
        text: replaceConsultationStatusType(data?.status, 'statusText'),
      },
      division: data?.user?.division,
      userId: data?.user?.id,
      position: data?.user?.position,
      consultant: data?.consultant,
      isClaim: data?.isClaim,
      isJustified: data?.isJustified,
      violator: data?.violator,
      violationReason: data?.violationreason,
      feedback: data?.feedback,
    };
    return new Array(1).fill(dataObject);
  }

  return [];
};

export const dataForTableUserConsultations = (data: TSingleConsultationInfo) => {
  if (typeof data === 'object' && data !== null) {
    const dataObject = {
      key: data?.id,
      id: data?.id,
      created: format(new Date(data?.created), 'dd.MM.yyyy'),
      topic: data?.topic,
      fio: `${data?.user?.lastName} ${data?.user?.name} ${data?.user?.middleName || ''}`,
      position: data?.user?.position,
      division: data?.user?.division,
      status: {
        type: replaceConsultationStatusType(data?.status, 'statusType'),
        text: replaceConsultationStatusType(data?.status, 'statusText'),
      },
    };
    return new Array(1).fill(dataObject);
  }

  return [];
};

export const replaceGetMethodRef = (value: string) => {
  if (value === 'hr') {
    return 'В кадровой службе';
  } else if (value === 'email') {
    return 'Скан на эл. почту';
  } else if (value === 'supervisor') {
    return 'У руководителя';
  }
  return ' Не определена';
};

export const dataForReferencesTable = (data: TReferencesDataInfo[] | null) => {
  if (Array.isArray(data)) {
    const dataForTable = data?.map((el: TReferencesDataInfo) => {
      return {
        key: el?.id,
        id: el?.id,
        created: format(new Date(el?.created), 'dd.MM.yyyy'),
        refTypeName: el?.refType?.name,
        year: el?.year,
        fio: `${el?.employee?.lastName} ${el?.employee?.name} ${el?.employee?.middleName || ''}`,
        gettingMethod: replaceGetMethodRef(el?.gettingMethod),
        status: {
          type: replaceConsultationStatusType(el?.status, 'statusType'),
          text: replaceConsultationStatusType(el?.status, 'statusText'),
        },
        hr: el?.hr,
        downtimeStatus: downtimeStatusCreated('references', el?.workingDaysPassed),
      };
    });

    return dataForTable;
  }
};

export const dataObjectForTableReferences = (data: TReferencesInfo) => {
  if (typeof data === 'object' && data !== null) {
    const dataObject: TPreparedReferencesData = {
      key: data?.id,
      id: data?.id,
      created: format(new Date(data?.created), 'dd.MM.yyyy'),
      status: {
        type: replaceConsultationStatusType(data?.status, 'statusType'),
        text: replaceConsultationStatusType(data?.status, 'statusText'),
      },
      fio: `${data?.employee?.lastName} ${data?.employee?.name} ${data?.employee?.middleName || ''}`,
      division: data?.employee?.division,
      userId: data?.employee?.id,
      position: data?.employee?.position,
      consultant: data?.consultant,
      personnelNumber: data?.employee?.personnelNumber,
      hr: data?.hr,
      accountant: data?.accountant,
      refTypeId: data?.refType?.id,
      refTypeName: data?.refType?.name,
      refTypeDepartment: data?.refType?.department,
      monthsAmount: data?.monthsAmount,
      gettingMethod: replaceGetMethodRef(data?.gettingMethod),
      comment: data?.comment,
      year: data?.year,
      downtimeStatus: downtimeStatusCreated('references', data?.workingDaysPassed),
      rejectionReason: data?.rejectionReason,
      amount: data?.amount,
    };
    const a: TPreparedReferencesData[] = [];
    a.push(dataObject);
    return a;
  }
};

export const dataObjectForReferencesTable = (data: TReferencesInfo) => {
  if (typeof data === 'object' && data !== null) {
    const dataObject: TPreparedReferencesUserDataInfo = {
      key: data?.id,
      id: data?.id,
      created: format(new Date(data?.created), 'dd.MM.yyyy'),
      status: {
        type: replaceConsultationStatusType(data?.status, 'statusType'),
        text: replaceConsultationStatusType(data?.status, 'statusText'),
      },
      fio: `${data?.employee?.lastName} ${data?.employee?.name} ${data?.employee?.middleName || ''}`,
      refTypeName: data?.refType?.name,
      gettingMethod: replaceGetMethodRef(data?.gettingMethod),
      year: data?.year,
    };
    return new Array(1).fill(dataObject);
  }
};

export const dataTableForEmployees = (data: TEmploee[] | undefined) => {
  if (Array.isArray(data)) {
    const dataForTable: DataEmployees[] = data?.map(el => {
      return {
        key: el?.id,
        fio: `${el?.lastName} ${el?.name} ${el?.middleName || ''} `,
        personnelNumber: el?.personnelNumber,
        division: el?.division?.name ? el.division.name : '',
        divisionId: el?.division?.divisionId ? el?.division?.divisionId : '',
        temporaryPassword: el?.temporaryPassword ? el?.temporaryPassword : null,
      };
    });
    return dataForTable;
  }
};

export const sortingDate = (a: string | undefined, b: string | undefined) => {
  let total = 0;
  if (a && b) {
    const start = a.split('.').reverse();
    const startNumber = new Date(start.join('-')).getTime();

    const end = b.split('.').reverse();
    const endNumber = new Date(end.join('-')).getTime();

    total = startNumber - endNumber;
  }
  return total;
};

export const configTabs = (role: string | null, arrayTabs: TItemsTab) => {
  const arr: TItemsTab = [];

  if (arrayTabs) {
    arrayTabs.forEach(el => {
      el.role.forEach(item => {
        if (role && role === item) {
          arr.push(el);
        }
      });
    });
    return arr;
  }
};

export const dataEmployeer = (data: TDataEmployeer[]) => {
  if (data?.length > 0) {
    const employeer = data?.map(elem => {
      return {
        key: elem?.id,
        id: elem?.id,
        vacationType: elem?.vacationType?.name,
        startedAt: format(new Date(elem?.startedAt), 'dd.MM.yyyy') || '2022-01-01',
        endedAt: format(new Date(elem?.endedAt), 'dd.MM.yyyy') || '2022-01-01',
        amountDays: elem?.amountDays,
        status: { ...elem?.status, isSupervisorApproved: elem.isSupervisorApproved },
        zupRequestStatus: elem?.zupRequestStatus,
        comment: elem?.comment,
      };
    });
    return employeer;
  }
};

export const dataForTableEmployeesSchedule = (data: TVacationScheduleInfo[] | undefined) => {
  if (Array.isArray(data)) {
    const dataSchedule = data?.map(el => {
      return {
        id: el?.id,
        personnelNumber: el?.personnelNumber,
        name: el?.name,
        lastName: el?.lastName,
        middleName: el?.middleName,
        position: el?.position,
        division: el?.division,
        scheduleRequests: dataEmployeer(el?.scheduleRequests),
      };
    });

    return dataSchedule;
  }
};

export const dataForFaqTable = (data: TFaqGetResponse[]): IPreparedFaqPublicated[] => {
  return data.map(elem => ({
    key: elem?.id,
    id: elem?.id,
    created: moment(elem.created, SERVER_DATE_MASK).format(PICKER_DATE_MASK),
    fio: `${elem?.author.lastName} ${elem?.author.name} ${elem?.author.middleName || ''}`,
    title: elem.title,
    category: elem.category ? elem.category.name : DEFAULT_CATEGORY_NAME,
    content: elem.content,
  }));
};

export const returnDays = (startedAt: string, endedAt: string) => {
  const start = moment(startedAt, PICKER_DATE_MASK);
  const end = moment(endedAt, PICKER_DATE_MASK);
  const diff = end.diff(start) / 1000 / 60 / 60 / 24 + 1;
  return diff || 0;
};

export const newDateOnJanuaryYear = (date: number) => {
  return `${date}-01-01`;
};

export const newDateOnDecemberYear = (date: number) => {
  return `${date}-12-31`;
};

export const changeDataForTableDays = (data: TTypeSchedule[]) => {
  if (data && data?.length > 0) {
    const newData = data.map(el => {
      return {
        key: (Math.random() + 1).toString(36).substring(7),
        id: el?.vacationTypeId,
        vacationType: el?.name,
        amountDays: el?.amountDays,
        resultDays: el?.amountDays,
      };
    });
    return newData as DataDaysScheduleType[];
  }
  return [];
};

export const calculateAllDays = (data: TTypeSchedule[]) => {
  let counter = 0;
  data.forEach(el => {
    counter += el.amountDays;
  });
  return counter;
};

const replaceAbsenceStatusType = (type: string) => {
  if (type === 'consideredByHR' || type === 'takenToWorkByHR' || type === 'changeResponsibleByHR') {
    return 'processing';
  }
  if (type === 'ready') {
    return 'success';
  }
  if (type === 'rejectedByHR') {
    return 'warning';
  }
  return 'warning';
};

export const dataForAbsencesTable = (data: TAbsentInfo[]) => {
  if (Array.isArray(data)) {
    const dataForTable = data?.map(el => {
      return {
        key: el?.id,
        id: el?.id,
        created: format(new Date(el?.created), 'dd.MM.yyyy'),
        period: `${format(new Date(el?.startedAt), 'dd.MM.yyyy')} - ${format(new Date(el?.endedAt), 'dd.MM.yyyy')}`,
        fio: `${el?.employee?.lastName} ${el?.employee?.name} ${el?.employee?.middleName || ''}`,
        status: {
          type: replaceAbsenceStatusType(el?.status.type),
          name: el?.status.name,
        },
        hr: el?.hr,
        zupRequestStatus: el?.zupRequestStatus,
      };
    });
    return dataForTable;
  }
  return [];
};

export const dataObjectForFormAbsences = (data: TAbsentSingleInfo) => {
  if (typeof data === 'object' && data !== null) {
    const dataArray: any[] = [];
    const dataObject = {
      key: data?.id,
      id: data?.id,
      created: format(new Date(data?.created), 'dd.MM.yyyy'),
      startedAt: format(new Date(data?.startedAt), 'dd.MM.yyyy'),
      endedAt: format(new Date(data?.endedAt), 'dd.MM.yyyy'),
      status: {
        type: replaceAbsenceStatusType(data?.status.type),
        name: data?.status.name,
      },
      fio: `${data?.employee?.lastName} ${data?.employee?.name} ${data?.employee?.middleName || ''} `,
      userId: data?.employee?.id,
      hr: data?.hr ? data.hr : null,
      employee: data?.employee,
      period: `${format(new Date(data?.startedAt), 'dd.MM.yyyy')} - ${format(new Date(data?.endedAt), 'dd.MM.yyyy')}`,
      supervisorComment: data?.supervisorComment,
      zupRequestStatus: data.zupRequestStatus,
      creator: data?.creator,
      hrComment: data.hrComment,
    };
    dataArray.push(dataObject);
    const array = dataArray;
    return array;
  }
  return [];
};

export const dataObjectForAbsencesTable = (data: TAbsentSingleInfoData) => {
  if (typeof data === 'object' && data !== null) {
    const dataArray: any[] = [];
    const dataObject: TPreparedSingleAbsenceTable = {
      key: data?.id,
      id: data?.id,
      created: format(new Date(data?.created), 'dd.MM.yyyy'),
      period: `${format(new Date(data?.startedAt), 'dd.MM.yyyy')} - ${format(new Date(data?.endedAt), 'dd.MM.yyyy')}`,
      fio: `${data?.employee?.lastName} ${data?.employee?.name} ${data?.employee?.middleName || ''} `,
      status: {
        type: replaceAbsenceStatusType(data?.status.type),
        name: data?.status.name,
      },
      zupRequestStatus: data.zupRequestStatus,
    };
    dataArray.push(dataObject);
    const array = dataArray;
    return array;
  }
  return [];
};

export const dataForRvdUsersTable = (data: TUserRvdInfo[], fromExcell = false): TPreparedRvdUsers[] => {
  const preparedUsers: TPreparedRvdUsers[] = data.map(elem => {
    return {
      id: elem.id!,
      key: elem.id!,
      created: '',
      toDate: moment(elem.toDate).format(PICKER_DATE_MASK),
      fio: `${elem.userInfo.lastName} ${elem.userInfo.name} ${elem.userInfo.middleName}`,
      personnelNumber: elem.userInfo.personnelNumber,
      division: elem.userInfo.division,
      type: checkRvdCompensationType(elem.type),
      isInVacation: elem.isInVacation,
      startWorkTime: elem.startTime,
      endWorkTime: elem.endTime,
      workDuration: '1',
      startBreakTime: elem.startBreakTime,
      endBreakTime: elem.endBreakTime,
      duration: calcWorkDayDuration(elem),
    };
  });
  return preparedUsers;
};

export const dataForOvertimeUsersTable = (data: TUserOvertimeInfo[]): TPreparedOvertimeUsers[] => {
  const preparedUsers: TPreparedOvertimeUsers[] = data.map(elem => {
    return {
      id: elem.id || 0,
      key: elem.id || 0,
      toDate: moment(elem.toDate).format(PICKER_DATE_MASK),
      fio: `${elem.userInfo.lastName} ${elem.userInfo.name} ${elem.userInfo.middleName}`,
      personnelNumber: elem.userInfo.personnelNumber,
      division: elem.userInfo.division,
      type: checkOvertimeCompensationType(elem.type),
      startWorkTime: elem.startTime,
      endWorkTime: elem.endTime,
      workDuration: calcWorkDayDurationOvertime(elem),
    };
  });
  return preparedUsers;
};

export const dataForOvertimeTable = (overtimes: TOvertimeGetResponse[]): TPreparedOvertime[] => {
  return overtimes.map(overtime => {
    return {
      id: overtime.id,
      key: overtime.id,
      created: moment(overtime.created).format(PICKER_DATE_MASK),
      count: overtime.count,
      status: overtime.status,
      docSignatory: overtime.docSignatory,
      responsible: `${overtime.hr?.lastName} ${overtime.hr?.name} ${overtime.hr?.middleName}`,
      userComment: overtime?.userComment,
      docNumber: overtime.docNumber,
    };
  });
};

export const dataForRvdTable = (rvds: TRvdResponseData[]): TPreparedRvd[] => {
  return rvds.map(rvd => {
    return {
      id: rvd.id,
      key: rvd.id,
      created: moment(rvd.created).format(PICKER_DATE_MASK),
      count: rvd.count,
      status: rvd.status as RvdStatusesBack,
      responsible: `${rvd.hr?.lastName} ${rvd.hr?.name} ${rvd.hr?.middleName}`,
      userComment: rvd.userComment || '',
      docNumber: rvd.docNumber,
    };
  });
};

export const dateForAdminsTable = (admins: AdminsData[]): AdminsDataPrepared[] => {
  return admins.map(admin => {
    const { name, lastName, middleName, ...newAdmin } = admin;
    const result: AdminsDataPrepared = {
      fio: `${lastName} ${name} ${middleName}`,
      ...newAdmin,
      acting: admin.acting,
      deputy: admin.deputy,
      timekeeper: admin.timekeeper,
      supervisor: admin.supervisor,
      organizationIds: admin.organizationIds,
    };
    return result;
  });
};

// проверка на равенство данных формы и данныхз с бэка
export const isSameFormValues = (
  saved: TSingleConsultationPreparedData,
  form: TConsultationsForm,
  isClaime: boolean | null,
) => {
  if (isClaime) {
    if (saved && form) {
      const isClaim = form?.isClaim;
      const subtopicId = form?.subtopicId && saved?.subtopic?.id && form.subtopicId === saved.subtopic.id;
      const isJustified = form?.isJustified === saved?.isJustified;
      const violationId = form?.violationId && saved?.violator?.id && form.violationId === saved.violator.id;
      const violationReasonId =
        form?.violationReasonId && saved?.violationReason?.id && form.violationReasonId === saved.violationReason.id;
      return !!isClaim && !!subtopicId && !!isJustified && !!violationId && !!violationReasonId;
    }
    return false;
  } else {
    const isClaim = !form?.isClaim;
    const subtopicId = form?.subtopicId && saved?.subtopic?.id && form.subtopicId === saved.subtopic.id;
    return !!isClaim && !!subtopicId;
  }
};

export const getErrorText = (e: TResponseErrorData) => {
  if (e?.data && isErrorData(e.data)) {
    return e.data?.message === 'Запрос справки не найден или не изменен'
      ? 'Нельзя поменять ответственного за заявку, переданную в бухгалтерию'
      : 'Что-то пошло не так';
  }
  return '';
};

export const createInitialRecord = (data: { id: string | number }[] | null): string => {
  if (data === null) return '';
  const initialRecord = data.map(item => item.id).join('');
  return initialRecord;
};

// получить сообщение по статусe из 1с
export const getZupStatusName = (status: ZupRequestStatusType): string => {
  switch (status) {
    case ZupRequestStatusType.processing:
      return 'Документ формируется';
    case ZupRequestStatusType.success:
      return 'Документ сформирован';
    case ZupRequestStatusType.error:
      return 'Ошибка при формировании';
  }
};

export const getColors = (): { [key: string]: string } => {
  // return colors;
  return {};
};

export const resetFormFields = (form: FormInstance) => {
  form.setFieldValue(OvertimeFormFields.employeeId, undefined);
  form.setFieldValue(OvertimeFormFields.toDate, undefined);
  form.setFieldValue(OvertimeFormFields.type, undefined);
  form.setFieldValue(OvertimeFormFields.isOnVacation, undefined);
  form.setFieldValue(OvertimeFormFields.workTime, undefined);
  form.setFieldValue(OvertimeFormFields.orderDate, undefined);
  form.setFieldValue(OvertimeFormFields.orderNumber, undefined);
  form.setFieldValue(OvertimeFormFields.signatory, undefined);
};

export const addNotifications = async (
  response: Promise<any>,
  success: string,
  error: string,
  callbackSuccess?: () => void,
) => {
  return response
    .then((e: any) => {
      if (e.error) {
        notification.error({ message: returnErrorOrMessage(e, 'Что-то пошло не так') });
      } else {
        callbackSuccess?.();
        notification.success({ message: success });
      }
    })
    .catch((e: any) => {
      notification.error({ message: returnErrorOrMessage(e, 'Что-то пошло не так') });
    });
};

export const rangeHoursDisabledTimePolls = (hours: number) => {
  const result: number[] = [];
  for (let i = 0; i < hours; i++) {
    result.push(i);
  }
  return result;
};

export const rangeMinutesDisabledTimePolls = (selectedHour: number, hours: number, minutes: number) => {
  if (selectedHour > hours) {
    return [];
  }

  const result: number[] = [];
  for (let i = 0; i <= minutes; i++) {
    result.push(i);
  }
  return result;
};

export const prepareDataForRvdLoading = (data: TRvdGetResponse | undefined) => {
  const preset: (string | number)[][] = [];
  if (data) {
    for (let user = 0; user < data.employees.length; user++) {
      const userRow: (string | number)[] = [];
      userRow[0] = user + 1;
      userRow[1] = data.employees[user].userInfo.personnelNumber;
      userRow[2] = `${data.employees[user].userInfo.lastName} ${data.employees[user].userInfo.name} ${data.employees[user].userInfo.middleName}`;
      userRow[3] = data.employees[user].userInfo.division;
      userRow[4] = data.employees[user].userInfo.position;
      userRow[5] = data.employees[user].isInVacation ? 'да' : 'нет';
      userRow[7] = data.employees[user].toDate;
      userRow[8] = data.employees[user].startTime;
      userRow[9] = data.employees[user].endTime;
      userRow[10] = data.employees[user].startBreakTime ?? '';
      userRow[11] = data.employees[user].endBreakTime ?? '';
      userRow[14] = RvdExcellCompensationTypeFromBack[data.employees[user].type];
      preset.push(userRow);
    }
  }
  return preset;
};

export const prepareDataForOvertimeLoading = (data: TOvertimeGetByIdResponse | undefined) => {
  const preset: (string | number)[][] = [];
  if (data) {
    for (let user = 0; user < data.employees.length; user++) {
      const userRow: (string | number)[] = [];
      userRow[0] = user + 1;
      userRow[1] = data.employees[user].userInfo.personnelNumber;
      userRow[2] = `${data.employees[user].userInfo.lastName} ${data.employees[user].userInfo.name} ${data.employees[user].userInfo.middleName}`;
      userRow[3] = data.employees[user].userInfo.division;
      userRow[4] = data.employees[user].userInfo.position;
      // userRow[5] = data.employees[user].isInVacation ? 'да' : 'нет';
      userRow[5] = data.employees[user].toDate;
      userRow[6] = data.employees[user].startTime;
      userRow[7] = data.employees[user].endTime;
      userRow[8] = OvertimeExcellCompensationTypeFromBack[data.employees[user].type];
      preset.push(userRow);
    }
  }
  return preset;
};

export const createPollExcelCommonInfo = (currentPoll: IPollGetByIdResponse | undefined) => {
  return [
    ['Общая информация', '', '', ''],
    ['Дата создания', 'Дата завершения', 'Дата публикации', 'Автор'],
    [
      moment(currentPoll?.created).utc().format(PICKER_DATE_MASK),
      currentPoll?.finishDate ? moment(currentPoll?.finishDate).utc().format(PICKER_DATE_MASK) : 'Не завершен',
      moment(currentPoll?.publicatedDate).utc().format(PICKER_DATE_MASK),
      `${currentPoll?.author.lastName} ${currentPoll?.author.name} ${currentPoll?.author.middleName} / ${currentPoll?.author.personnelNumber}`,
    ],

    ['', '', '', ''],

    ['Пользователь', 'Ответ', 'Дата ответа', 'Вопрос'],
  ];
};

export const createDayOffExcelCommonInfo = () => {
  return [['№', 'Дата', 'ФИО', ' Дата отгула', 'Длительность', 'Статус']];
};

export const divideToPairs = (val: string) => {
  const result: string[] = [];
  const target = val.split('@')[0];
  for (let i = 0; i < target.length; i++) {
    if (i >= 1) {
      const pair = target
        .substring(i - 1, i + 1)
        .replace(/\./g, '\\.')
        .replace(/\*/g, '\\*')
        .replace(/\$/g, '\\$');
      result.push(pair);
    }
  }
  return result;
};

export const generatePass = async (count: number, validateData: { regExp?: RegExp; login?: string }) => {
  const digits = '0123456789';
  const bigChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const chars = 'abcdefghijklmnopqrstuvwxyz';
  const symbols = '@#$&*%';
  let { login, regExp } = validateData;

  if (!login) {
    login = '123@email.com';
  }

  if (!regExp) {
    regExp = new RegExp(
      `^(?!.*(${divideToPairs(login || '').join(
        '|',
      )}))(?=.*[A-Z])(?=.*\\d)(?=.*[@#$&*%])[A-Za-z\\d@#$&*%!^+-=~\\\`]{${count},}$`,
    );
  }

  const signs: string[] = [digits, chars, bigChars, symbols];

  let randomstring = '';

  if (count < 6) {
    count = 6;
  }

  // Делаем начальную строку, чтобы точно содержала каждый символ
  randomstring += digits[Math.floor(Math.random() * digits.length)];
  randomstring += chars[Math.floor(Math.random() * chars.length)];
  randomstring += symbols[Math.floor(Math.random() * symbols.length)];
  randomstring += bigChars[Math.floor(Math.random() * bigChars.length)];

  const diff = randomstring.length;
  let result = randomstring;

  //Пересоздаем последовательность, пока не начнет удовлетворять регулярке
  while (!regExp.test(result)) {
    result = randomstring;
    for (let i = 0; i < count - diff; i++) {
      const signsString = signs[Math.floor(Math.random() * signs.length)];
      const randomSignIndex = Math.floor(Math.random() * signsString.length);
      result += signsString.substring(randomSignIndex, randomSignIndex + 1);
    }
  }

  return result;
};

export const dataForVacationApplicationSupervisorTable = (
  data: VacationSupervisor[],
): TPreparedVacationSupervisorInfoData[] => {
  return data.map(elem => {
    const { amountDays, endedAt, startedAt, id, type, status, vacationType } = elem.request;
    return {
      amountDays,
      endedAt: dayjs(endedAt, SERVER_DATE_MASK).format(PICKER_DATE_MASK),
      id,
      startedAt: dayjs(startedAt, SERVER_DATE_MASK).format(PICKER_DATE_MASK),
      status: status,
      type: replaceType(type),
      vacationType: vacationType?.name || 'Отпуск без сохранения зарплаты',
      fio: `${elem?.employee?.lastName} ${elem?.employee?.name} ${elem?.employee?.middleName}`,
      key: id,
      employeeId: elem.employee?.id,
    };
  });
};

export const dataForDayOffSupervisorTable = (data: TDayOffSupervisorResponse[]): TPerparedDayOffSupervisor[] => {
  return data.map(elem => {
    const { amount, created, date, id, status, rejectionReason } = elem.request;
    const startDate = format(new Date(date), 'dd.MM.yyyy');
    const endDate = dayjs(date, SERVER_DATE_MASK).add(amount - 1, 'day');
    return {
      amount,
      created,
      id,
      date: startDate,
      endDate: format(endDate.toDate(), 'dd.MM.yyyy'),
      status: status,
      fio: `${elem?.employee?.lastName} ${elem?.employee?.name} ${elem?.employee?.middleName}`,
      key: id,
      rejectionReason,
    };
  });
};

export const dataForDayOffCanceledSupervisorTable = (
  data: TDayOffSupervisorResponse[],
): TPerparedDayOffSupervisor[] => {
  return data.map(elem => {
    const { amount, created, date, id, status, rejectionReason } = elem.request;
    const startDate = format(new Date(date), 'dd.MM.yyyy');
    const endDate = dayjs(date, SERVER_DATE_MASK).add(amount - 1, 'day');
    return {
      amount,
      created,
      id: Number(elem.canceledRequest?.id),
      date: startDate,
      endDate: format(endDate.toDate(), 'dd.MM.yyyy'),
      status: elem.canceledRequest?.status || '',
      fio: `${elem?.employee?.lastName} ${elem?.employee?.name} ${elem?.employee?.middleName}`,
      key: id,
      rejectionReason,
    };
  });
};

export const dataForAbsenceSupervisorTable = (
  payload: TAbsenceGetResponseSubstitution[],
): TPreparedAbsenceSupervisor[] => {
  return payload?.map(data => {
    return {
      key: data?.id,
      id: data?.id,
      created: format(new Date(data?.created), 'dd.MM.yyyy'),
      period: `${format(new Date(data?.startedAt), 'dd.MM.yyyy')} - ${format(new Date(data?.endedAt), 'dd.MM.yyyy')}`,
      fio: `${data?.employee?.lastName} ${data?.employee?.name} ${data?.employee?.middleName || ''}`,
      status: {
        type: data?.status.type,
        name: data?.status.name,
      },
      hr: null,
      zupRequestStatus: null,
      comment: data?.comment,
    };
  });
};

export const checkIsUsersDublicate = (employees: TUserRvdInfo[] | TUserOvertimeInfo[]): boolean => {
  const checkUnuque = {};

  for (const user of employees) {
    if (checkUnuque[user.userInfo.id + user.toDate]) {
      return true;
    }
    checkUnuque[user.userInfo.id + user.toDate] = true;
  }
  return false;
};

/** Получить время в UTC */
export const dateTimeToUtc = (dateTime: string): { utcDate: string; utcTime: string } => {
  const utcOffset = Math.floor(dayjs().utcOffset() / 60);
  /** Получаем выбранное время в формате utc */
  const utcDateTime = dayjs(dateTime, PICKER_DATE_MASK_PREPARE_UTC).add(-utcOffset, 'h');
  const utcDate = utcDateTime.format(SERVER_DATE_MASK);
  const utcTime = utcDateTime.format(PICKER_TIME_MASK);

  return { utcDate, utcTime };
};

/** Получить разницу в часах между текущим временем в текущем часовом поясе и UTC */
export const getTimeDiff = (time: string | undefined | null, plus = false): number => {
  const timeHours = dayjs(time, PICKER_TIME_MASK).hour();
  const utcOffset = Math.floor(dayjs().utcOffset() / 60);
  const timeDiff = plus ? timeHours + utcOffset : timeHours - utcOffset;
  return timeDiff;
};

/** Получить сдвинутые на один день вперед дни публикации */
export const getUtcDays = (days: WeekDays[], plus = false): WeekDaysBack[] => {
  const weekDays = Object.values(WeekDaysBack);
  return days.map(elem => {
    const idx = weekDays.indexOf(WeekDaysToBack[elem]);
    // В зависимости от того текуущий часовой пояс больше или меньше utc считаем новый сдвинутый индекс
    const shiftedIndex = plus ? (idx + 1 > weekDays.length ? 0 : idx + 1) : idx - 1 < 0 ? weekDays.length - 1 : idx - 1;
    return weekDays[shiftedIndex];
  });
};

/** Получить нормальные публикации из сдвинутых при применении времени UTC */
export const getNormalDays = (days: WeekDaysBack[], plus = false): WeekDays[] => {
  const weekDays = Object.values(WeekDays);
  return days.map(elem => {
    const idx = weekDays.indexOf(WeekDaysToFront[elem]);
    const shiftedIndex = plus ? (idx + 1 > weekDays.length ? 0 : idx + 1) : idx - 1 < 0 ? weekDays.length - 1 : idx - 1;
    return weekDays[shiftedIndex];
  });
};

/** Привести время из UTC к текущему часовому поясу */
export const dateTimeToNormal = (
  date: string | undefined,
  time: string,
): { normalDate: string; normalTime: string } => {
  const formattedStartDate = date ? dayjs(date).format(SERVER_DATE_MASK) : '';
  const dateTime = `${formattedStartDate} ${time}`;
  const utcOffset = Math.floor(dayjs().utcOffset() / 60);
  /** Получаем выбранное время в формате utc */
  const normalDateTime = dayjs(dateTime, PICKER_DATE_MASK_PREPARE_UTC).add(utcOffset, 'h');
  const normalDate = normalDateTime.format(SERVER_DATE_MASK);
  const normalTime = normalDateTime.format(PICKER_TIME_MASK);

  return { normalDate, normalTime };
};

/** Подготавливает дату и время при заполнении полей формы при инициализации компонента */
export const prepareDateTimeToFill = (data: INewsGetResponse) => {
  const normalDateTime = dateTimeToNormal(data.startDate, data.time);
  const isRetryOnceOrWeekly = data.retry === FrequencyDatesBack.ONCE || data.retry === FrequencyDatesBack.WEEKLY;
  const normalDatesToCreate = data.datesToCreate.map(elem => dateTimeToNormal(elem, data.time).normalDate);
  const normalDate = isRetryOnceOrWeekly ? normalDateTime.normalDate : undefined;
  const normalTime = isRetryOnceOrWeekly
    ? normalDateTime.normalTime
    : dateTimeToNormal(data.datesToCreate[0], data.time).normalTime;

  let normalDays: WeekDays[] = data.days.map(day => WeekDaysToFront[day]);

  if (data.retry === FrequencyDatesBack.WEEKLY) {
    const timeDiff = getTimeDiff(data.time, true);

    //Если разница текущего времени и сдвига UTC меньше нуля,
    //то сдвигаем все дни на один индекс вперед,
    //если не выбраны все дни недели.
    //Происходит процесс, обратный тому, что происходит при создании новости.
    if (data.days.length >= 7) {
      return { normalDate, normalTime, normalDatesToCreate, normalDays };
    }
    // Если часовой пояс меньше чем UTC
    if (timeDiff < 0) {
      normalDays = getNormalDays(data.days);
    }
    // Если часовой пояс больше чем UTC
    else if (timeDiff >= 24) {
      normalDays = getNormalDays(data.days, true);
    }
  }

  return { normalDate, normalTime, normalDatesToCreate, normalDays };
};

/** Подготавливает дату и время при сохранении новости  */
export const prepareDateTimeToSave = ({ datesToCreate, days, retry, startDate, time }: TPrepareNewsToSaveData) => {
  const utcDateTime = dateTimeToUtc(`${startDate} ${time}`);
  const isRetryOnceOrWeekly = retry === FrequencyDates.ONCE || retry === FrequencyDates.WEEKLY;
  const utcDatesToCreate = datesToCreate.map(elem => dateTimeToUtc(`${elem} ${time}`).utcDate);
  const utcDate = isRetryOnceOrWeekly ? utcDateTime.utcDate : undefined;
  const utcTime = isRetryOnceOrWeekly ? utcDateTime.utcTime : dateTimeToUtc(`${datesToCreate[0]} ${time}`).utcTime;

  let utcDays: WeekDaysBack[] = days
    .filter(elem => elem !== WeekDays.EVERY_DAY_CHECKBOX)
    .map(day => WeekDaysToBack[day]);

  if (retry === FrequencyDates.WEEKLY) {
    const timeDiff = getTimeDiff(time);
    //Если разница текущего времени и сдвига UTC меньше нуля,
    //то сдвигаем все дни на один индекс вперед,
    //если не выбраны все дни недели
    if (days.length >= 7) {
      return { utcDate, utcTime, utcDatesToCreate, utcDays };
    }
    // Если часовой пояс больше чем UTC
    if (timeDiff < 0) {
      utcDays = getUtcDays(days);
    }
    // Если часовой пояс меньше чем UTC
    else if (timeDiff >= 24) {
      utcDays = getUtcDays(days, true);
    }
  }

  return { utcDate, utcTime, utcDatesToCreate, utcDays };
};

export const checkEmployeesRvdType = (empls: RvdUserPreparedInfo[]) => {
  // формируем массивы по сотрудникам
  const users: Record<number, RvdCompensationType> = {};

  for (const empl of empls) {
    if (!users[empl.employeeId]) {
      users[empl.employeeId] = empl.type;
    } else if (users[empl.employeeId] !== empl.type) {
      throw new Error('Нельзя отправлять в 1С РВД с разными типами компенсации у одного и того же сотрудника.');
    }
  }
};

export const checkEmployeesOvertimeType = (empls: OvertimeUserPreparedInfo[]) => {
  // формируем массивы по сотрудникам
  const users: Record<number, OvertimeCompensationType> = {};

  for (const empl of empls) {
    if (!users[empl.employeeId]) {
      users[empl.employeeId] = empl.type;
    } else if (users[empl.employeeId] !== empl.type) {
      throw new Error(
        'Нельзя отправлять в 1С Сверхурочный с разными типами компенсации у одного и того же сотрудника.',
      );
    }
  }
};

export const checkEmployeesOvertimeFourHoursInTwoDayType = (empls: OvertimeUserPreparedInfo[]) => {
  // формируем массивы по сотрудникам
  const users: Record<number, Record<string, number>> = {};

  for (const empl of empls) {
    if (!users[empl.employeeId]) {
      users[empl.employeeId] = {};
    }

    const yesterday = dayjs(empl.toDate, SERVER_DATE_MASK).add(-1, 'day').format(SERVER_DATE_MASK);
    const tomorrow = dayjs(empl.toDate, SERVER_DATE_MASK).add(1, 'day').format(SERVER_DATE_MASK);

    const yesterdayHours = users[empl.employeeId][yesterday];
    const tomorrowHours = users[empl.employeeId][tomorrow];

    const end = dayjs(empl.endTime, 'HH:mm');
    const start = dayjs(empl.startTime, 'HH:mm');

    const diff = end.diff(start);
    const forHours = 1000 * 60 * 60 * 4;
    // Убрана проверка т.к. она не должна работать для локального персонала
    // if (diff > forHours) {
    //   throw new Error(WORK_TIME_OVER_MESSAGE_OVERTIME);
    // }
    const addHours = (yesterdayHours || 0) > (tomorrowHours || 0) ? yesterdayHours : tomorrowHours;

    if (!users[empl.employeeId][empl.toDate]) {
      users[empl.employeeId][empl.toDate] = diff + (addHours || 0);
    } else {
      users[empl.employeeId][empl.toDate] += diff + (addHours || 0);
    }
    // Убрана проверка т.к. она не должна работать для локального персонала
    // if (users[empl.employeeId][empl.toDate] > forHours) {
    //   throw new Error(WORK_TIME_OVER_MESSAGE_OVERTIME);
    // }
  }
};
